import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const serviceId = 3
const slug = 'retaining-walls-and-shoring-sydney';
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Retaining Walls & Shoring Sydney | ${BUSINESS_NAME}`,
        description: "Engineered concrete retaining systems for stability and support. Expert retaining walls and shoring services in Sydney.",
        keywords: "retaining walls sydney, shoring services, concrete retaining systems, soil stabilization, erosion control, landscape retaining walls, structural support, commercial retaining walls, residential retaining walls, custom wall design, construction project management, sydney builders",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Retaining Walls & Shoring',
    description: 'Engineered concrete retaining systems for stability and support.',
    points: [
    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
